// extracted by mini-css-extract-plugin
export default {"avatarContainer":"SelectAvatarDialog_avatarContainer__45Jiq","active":"SelectAvatarDialog_active__QixHQ"};